import heigitlogo from "../assets/img/HeiGIT_Logo_base02.svg";

export default {
  name: "Example",
  components: {
    heigitlogo
  }
};
